import React from 'react';

import DashboardComptes from 'components/Comptes/DashboardComptes';

const PageComptes: React.FC = () => {
  return <DashboardComptes />;
};

export default PageComptes;
